export enum PurposesTypes {
  PURPOSES,
  ARCHIVE,
}
